import { createFileRoute } from '@tanstack/react-router'
import { RegisterPage } from '../components/auth-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/registrazione')({
  head: () => noIndexRouteHead('register', 'it'),
  component: RegisterPage,
})
